addDaysFns